import { ArrowForwardRounded } from '@mui/icons-material';
import { type JSX, type PropsWithChildren } from 'react';
import { Link as ReactRouterLink } from 'react-router';

type Props = {
  readonly url: string;
  readonly newTab?: boolean;
};

export const Link = ({ url, newTab, children }: PropsWithChildren<Props>): JSX.Element => (
  <ReactRouterLink
    to={url}
    target={newTab ? '_blank' : undefined}
    style={{ marginRight: '4px', alignItems: 'center', display: 'flex', textDecoration: 'none', fontWeight: 500 }}
  >
    {children}
    <ArrowForwardRounded sx={{ ml: 0.5 }} />
  </ReactRouterLink>
);
